import { Injectable, inject } from '@angular/core';
import {ApiNotificationListResponseDto, ApiNotificationPatchResponseDto, ApiNotificationResponseDto, NotificationsApiService} from '@birco/rainmesh-api';
import {Observable} from 'rxjs';
import {NotificationStateService} from '../api/notification-state-service.interface';
import {NotificationFilter} from '../../../features/notifications/state/notification.state';

@Injectable({
  providedIn: 'root'
})
export class NotificationStateServiceImpl implements NotificationStateService {
  private notificationsApiService = inject(NotificationsApiService);


  getNotifications(options: NotificationFilter): Observable<ApiNotificationListResponseDto> {
    return this.notificationsApiService.getNotifications(
      options.pageSize,
      options.page,
      options.level,
      options.type,
      options.readState !== 'unread',
    );
  }

  markAsRead(options: { id: string }): Observable<ApiNotificationResponseDto> {
    return this.notificationsApiService.markAsRead(options.id);
  }

  markAllAsRead(): Observable<ApiNotificationPatchResponseDto> {
    return this.notificationsApiService.markNotificationsAsRead();
  }

  deleteAll(): Observable<void> {
    return this.notificationsApiService.deleteNotifications();
  }
}
